const PACKAGE_VERSION = "1.43.2";
const TARGETED_RPC_VERSION = "1.60.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
